module.exports = __webpack_public_path__ + "static/media/edra.12e4bb09.svg";